import React from "react";
import "../assets/css/HomeBanner.css";
import Carousel from "./Carousel";

function HeroBanner() {
  return (
    <div>
      <div className="container d-flex flex-column">
        <h1 className="text-center mt-3 font-green-colour display-3 font-weight-bold">राजस्थान के शिक्षा में बढ़ते कदम</h1>
        <h4 className="text-center mb-6">
       <span className="font-green-colour"> हमारा लक्ष्य: </span> सभी विद्यार्थियों को अपने कक्षा-स्तर की दक्षताओं में सक्षम बनाना | 

        </h4>
      </div>
      <section id="hero" className="d-flex align-items-center flex-column">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-5 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
               
              <br />
              <h5 className=" mb-6">इसके 4 मुख्य पहलू हैं:</h5>
              <ul>
                <li className="mt-3 d-flex flex-row">
                  <i className="bi check bi-check-circle-fill"></i>  <p className="text-dark">2 लाख+ शिक्षकों के लिए शिक्षक ऐप</p> <br/> 
                </li>
                <li className="mt-3 d-flex flex-row">
                  <i className="bi check bi-check-circle-fill"></i>  <p className="text-dark">विद्यार्थियों  के लिए दक्षता आधारित कार्यपुस्तिकाएँ </p> <br/> 
                </li>
                <li className="mt-3 d-flex flex-row" >
                  <i className="bi check bi-check-circle-fill"></i><p className="text-dark">विद्यार्थियों  के दक्षता आधारित योगात्मक आकलन</p> <br/>  
                </li>
                <li className="mt-3 d-flex flex-row">
                  <i className="bi check bi-check-circle-fill"></i><p className="text-dark">अभिभावकों के हाथ में उनके बच्चों की दक्षता आधारित रिपोर्ट कार्ड</p> <br/>   
                </li>
              </ul>
              {/* <p>यदि आपके "राजस्थान के शिक्षा में बढ़ते कदम" कार्यक्रम से सम्बंधित कोई सुझाव हो तो इस Google Form के द्वारा साझा करें:</p> */}
              <div className="button-container d-flex justify-content-center justify-content-lg-start">
                {/* <a href="https://docs.google.com/forms/d/1ntxDyDkiKy9NBnOlXWpLU6s6E_HQb8RoOGBLNSsc0qk/edit" className="btn-get-started scrollto">
                सवाल यहाँ साझा करें  <i className="mx-2 bi bi-arrow-right"></i>
                </a> */}
              </div>
            </div>
            <div
              className="col-lg-7 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-1 order-lg-1"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              {/* <img
                src={HomeBannerImage}
                className="img-fluid animated"
                alt=""
              /> */}
              <Carousel />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HeroBanner;